module.exports = __webpack_public_path__ + "static/media/trainer.bdcd86c6.svg";